"use client";

import { formatDistanceToNow } from "date-fns";
import { Send } from "lucide-react";
import { Doc } from "@convex/_generated/dataModel";

interface SentEmailListItemProps {
  email: Doc<"sentEmails">;
  onClick: () => void;
}

export function SentEmailListItem({ email, onClick }: SentEmailListItemProps) {
  return (
    <div
      onClick={onClick}
      className="p-4 border-b cursor-pointer hover:bg-muted/50 transition-colors"
    >
      <div className="flex items-start gap-3">
        <div className="mt-1">
          <Send className="h-5 w-5 text-muted-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm truncate">
              To: {email.recipientName || email.recipient}
            </p>
            <span className="text-xs text-muted-foreground whitespace-nowrap">
              {formatDistanceToNow(email.sentAt, { addSuffix: true })}
            </span>
          </div>
          <p className="text-sm text-muted-foreground truncate">
            {email.subject}
          </p>
          <p className="text-xs text-muted-foreground truncate mt-1">
            {email.bodyPreview}
          </p>
        </div>
      </div>
    </div>
  );
}
